import React from 'react';

const LoadingIndicator = () => {
  return <div className="loading-indicator"></div>;
};

export default LoadingIndicator;
